import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ResourcesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Resources', count: 12 },
    { id: 'guides', name: 'Technical Guides', count: 5 },
    { id: 'whitepapers', name: 'Whitepapers', count: 3 },
    { id: 'case-studies', name: 'Case Studies', count: 2 },
    { id: 'datasheets', name: 'Material Datasheets', count: 2 },
  ];

  const resources = [
    {
      id: 1,
      category: 'guides',
      title: 'Complete Guide to Injection Molding',
      description: 'Comprehensive 45-page guide covering injection molding fundamentals, material selection, design considerations, and troubleshooting common issues.',
      pages: '45 pages',
      format: 'PDF',
      size: '8.2 MB',
      image: 'https://public.readdy.ai/ai/img_res/0c8c341c0b873300e128d497474b7081.jpg',
      downloadUrl: '#',
    },
    {
      id: 2,
      category: 'guides',
      title: 'Blow Molding Design Best Practices',
      description: 'Essential design guidelines for blow molded parts including wall thickness optimization, draft angles, and material flow considerations.',
      pages: '32 pages',
      format: 'PDF',
      size: '5.8 MB',
      image: 'https://readdy.ai/api/search-image?query=technical%20guide%20cover%20showing%20blow%20molding%20bottle%20design%20with%20professional%20layout%20clean%20design%20featuring%20hollow%20part%20cross%20sections%20and%20design%20specifications&width=400&height=300&seq=resource-blow-guide-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 3,
      category: 'guides',
      title: '3D Printing Technology Comparison',
      description: 'Detailed comparison of FDM, SLA, SLS, and MJF technologies with application recommendations and material properties.',
      pages: '28 pages',
      format: 'PDF',
      size: '6.5 MB',
      image: 'https://readdy.ai/api/search-image?query=technical%20document%20cover%20showing%20different%203d%20printing%20technologies%20comparison%20with%20professional%20layout%20clean%20design%20featuring%20various%20printing%20methods%20and%20sample%20parts&width=400&height=300&seq=resource-3d-guide-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 4,
      category: 'guides',
      title: 'Mold Design for Manufacturability',
      description: 'Expert guidance on designing molds that optimize production efficiency, reduce costs, and ensure consistent quality.',
      pages: '38 pages',
      format: 'PDF',
      size: '7.1 MB',
      image: 'https://readdy.ai/api/search-image?query=technical%20guide%20cover%20showing%20mold%20design%20cad%20drawings%20with%20professional%20layout%20clean%20design%20featuring%20tooling%20cross%20sections%20and%20engineering%20specifications&width=400&height=300&seq=resource-mold-design-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 5,
      category: 'guides',
      title: 'Quality Control in Precision Molding',
      description: 'Comprehensive overview of quality control methods, inspection techniques, and statistical process control for molding operations.',
      pages: '35 pages',
      format: 'PDF',
      size: '6.8 MB',
      image: 'https://readdy.ai/api/search-image?query=technical%20document%20cover%20showing%20quality%20inspection%20equipment%20and%20measurement%20tools%20with%20professional%20layout%20clean%20design%20featuring%20precision%20instruments%20and%20quality%20charts&width=400&height=300&seq=resource-quality-guide-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 6,
      category: 'whitepapers',
      title: 'AI-Powered Quality Control in Manufacturing',
      description: 'Research paper exploring the implementation of artificial intelligence and machine learning for real-time defect detection and process optimization.',
      pages: '22 pages',
      format: 'PDF',
      size: '4.2 MB',
      image: 'https://readdy.ai/api/search-image?query=professional%20whitepaper%20cover%20showing%20ai%20artificial%20intelligence%20in%20manufacturing%20with%20clean%20modern%20design%20featuring%20neural%20networks%20and%20quality%20inspection%20visualization&width=400&height=300&seq=resource-ai-whitepaper-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 7,
      category: 'whitepapers',
      title: 'Sustainable Manufacturing Practices',
      description: 'Analysis of eco-friendly materials, energy-efficient processes, and circular economy principles in modern molding operations.',
      pages: '26 pages',
      format: 'PDF',
      size: '5.1 MB',
      image: 'https://readdy.ai/api/search-image?query=professional%20whitepaper%20cover%20about%20sustainable%20manufacturing%20with%20clean%20modern%20design%20featuring%20green%20technology%20recycling%20symbols%20and%20eco%20friendly%20production&width=400&height=300&seq=resource-sustainability-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 8,
      category: 'whitepapers',
      title: 'Medical Device Manufacturing Standards',
      description: 'Detailed examination of FDA regulations, ISO 13485 requirements, and best practices for medical-grade molding.',
      pages: '30 pages',
      format: 'PDF',
      size: '5.9 MB',
      image: 'https://readdy.ai/api/search-image?query=professional%20whitepaper%20cover%20about%20medical%20device%20manufacturing%20with%20clean%20modern%20design%20featuring%20medical%20equipment%20regulatory%20symbols%20and%20quality%20standards&width=400&height=300&seq=resource-medical-whitepaper-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 9,
      category: 'case-studies',
      title: 'Automotive Component Success Story',
      description: 'How we helped a leading automotive manufacturer reduce production costs by 30% while improving part quality through optimized tooling design.',
      pages: '12 pages',
      format: 'PDF',
      size: '3.5 MB',
      image: 'https://readdy.ai/api/search-image?query=professional%20case%20study%20cover%20showing%20automotive%20plastic%20components%20with%20clean%20modern%20design%20featuring%20car%20parts%20manufacturing%20process%20and%20success%20metrics&width=400&height=300&seq=resource-automotive-case-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 10,
      category: 'case-studies',
      title: 'Medical Device Rapid Prototyping',
      description: 'Case study detailing our 3-week turnaround for FDA-compliant medical device prototypes using advanced 3D printing and injection molding.',
      pages: '10 pages',
      format: 'PDF',
      size: '3.2 MB',
      image: 'https://readdy.ai/api/search-image?query=professional%20case%20study%20cover%20showing%20medical%20device%20prototypes%20with%20clean%20modern%20design%20featuring%20healthcare%20equipment%20rapid%20development%20process%20and%20results&width=400&height=300&seq=resource-medical-case-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 11,
      category: 'datasheets',
      title: 'Engineering Plastics Material Guide',
      description: 'Comprehensive datasheet covering ABS, PC, PA, POM, and other engineering plastics with mechanical properties, processing parameters, and applications.',
      pages: '18 pages',
      format: 'PDF',
      size: '2.8 MB',
      image: 'https://readdy.ai/api/search-image?query=technical%20datasheet%20cover%20showing%20plastic%20material%20samples%20and%20properties%20with%20professional%20layout%20clean%20design%20featuring%20material%20specifications%20and%20test%20results&width=400&height=300&seq=resource-materials-datasheet-001&orientation=landscape',
      downloadUrl: '#',
    },
    {
      id: 12,
      category: 'datasheets',
      title: 'High-Performance Polymers Reference',
      description: 'Technical specifications for PEEK, PEI, PSU, and other high-performance materials suitable for demanding applications.',
      pages: '15 pages',
      format: 'PDF',
      size: '2.5 MB',
      image: 'https://readdy.ai/api/search-image?query=technical%20datasheet%20cover%20showing%20high%20performance%20polymer%20samples%20with%20professional%20layout%20clean%20design%20featuring%20advanced%20material%20properties%20and%20chemical%20structures&width=400&height=300&seq=resource-polymers-datasheet-001&orientation=landscape',
      downloadUrl: '#',
    },
  ];

  const filteredResources = selectedCategory === 'all' 
    ? resources 
    : resources.filter(resource => resource.category === selectedCategory);

  const handleDownload = (resourceTitle: string) => {
    alert(`Download functionality for "${resourceTitle}" will be available soon. Please contact us at info@alpineprecisionmold.com to request this resource.`);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=technical%20library%20with%20engineering%20documents%20and%20digital%20resources%20modern%20knowledge%20center%20with%20organized%20technical%20guides%20and%20manufacturing%20documentation%20professional%20resource%20center&width=1920&height=800&seq=resources-hero-bg-001&orientation=landscape)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 bg-primary-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-book-open-line text-primary-300"></i>
              <span className="text-sm font-medium text-primary-300">Knowledge Center</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-display font-bold text-white mb-6">
              Technical Resources & Guides
            </h1>
            <p className="text-xl text-slate-300 mb-8 leading-relaxed">
              Access our comprehensive library of technical guides, whitepapers, case studies, and material datasheets. Download expert knowledge to optimize your manufacturing projects.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Resources */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <div className="text-4xl font-display font-bold text-primary-600 mb-2">12+</div>
              <div className="text-slate-700 font-medium">Technical Documents</div>
            </div>

            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-download-cloud-line text-3xl text-white"></i>
              </div>
              <div className="text-4xl font-display font-bold text-primary-600 mb-2">Free</div>
              <div className="text-slate-700 font-medium">Instant Downloads</div>
            </div>

            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-3xl text-white"></i>
              </div>
              <div className="text-4xl font-display font-bold text-primary-600 mb-2">Monthly</div>
              <div className="text-slate-700 font-medium">Content Updates</div>
            </div>
          </div>
        </div>
      </section>

      {/* Resources Library */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-display font-bold text-slate-900 mb-4">
              Browse Our Library
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              Filter by category to find the resources most relevant to your needs.
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-lg shadow-primary-500/30'
                    : 'bg-white text-slate-700 hover:bg-slate-100'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>

          {/* Resources Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredResources.map((resource) => (
              <div key={resource.id} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
                <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                  <img
                    src={resource.image}
                    alt={resource.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center space-x-2 mb-3">
                    <span className="px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                      {categories.find(c => c.id === resource.category)?.name.replace(/s$/, '')}
                    </span>
                    <span className="text-xs text-slate-500">{resource.format}</span>
                  </div>
                  
                  <h3 className="text-xl font-display font-bold text-slate-900 mb-3">
                    {resource.title}
                  </h3>
                  
                  <p className="text-slate-600 text-sm leading-relaxed mb-4">
                    {resource.description}
                  </p>

                  <div className="flex items-center justify-between text-xs text-slate-500 mb-4">
                    <span className="flex items-center space-x-1">
                      <i className="ri-file-line"></i>
                      <span>{resource.pages}</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <i className="ri-hard-drive-line"></i>
                      <span>{resource.size}</span>
                    </span>
                  </div>

                  <button
                    onClick={() => handleDownload(resource.title)}
                    className="w-full px-4 py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-semibold rounded-lg hover:from-primary-600 hover:to-primary-700 transition-all shadow-lg shadow-primary-500/30 flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-download-line"></i>
                    <span>Download Free</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl p-12 text-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-line text-4xl text-white"></i>
            </div>
            <h2 className="text-3xl font-display font-bold text-white mb-4">
              Get New Resources Delivered
            </h2>
            <p className="text-xl text-primary-100 mb-8">
              Subscribe to receive notifications when we publish new technical guides and resources.
            </p>
            <div className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 rounded-lg text-slate-900 placeholder-slate-400 focus:ring-2 focus:ring-white focus:outline-none text-sm"
                />
                <button className="px-6 py-3 bg-white text-primary-600 font-semibold rounded-lg hover:bg-slate-100 transition-all whitespace-nowrap cursor-pointer">
                  Subscribe
                </button>
              </div>
              <p className="text-xs text-primary-200 mt-3">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Need Help Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-display font-bold text-slate-900 mb-4">
              Need Personalized Guidance?
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto mb-8">
              Our technical team is here to help you find the right solutions for your specific manufacturing challenges.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="/contact"
                className="px-8 py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-semibold rounded-lg hover:from-primary-600 hover:to-primary-700 transition-all shadow-lg shadow-primary-500/30 whitespace-nowrap cursor-pointer"
              >
                Contact Our Experts
              </a>
              <a
                href="/instant-quote"
                className="px-8 py-3 bg-white text-slate-700 font-semibold rounded-lg hover:bg-slate-100 transition-all border border-slate-300 whitespace-nowrap cursor-pointer"
              >
                Get Instant Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ResourcesPage;
